import { BottomNavigation, Stack, useTheme } from "@mui/material"
import { CommonBtn } from "../../../components";

interface BottomSaveBarProps {
    onSave: () => void;
    childrenActions?: React.ReactNode
    disabled?: boolean
    saveLabel?: string
}

const BottomSaveBar: React.FC<BottomSaveBarProps> = ({ onSave, childrenActions, disabled = false, saveLabel = 'Save' }) => {
    const theme = useTheme();
    return (
        <BottomNavigation showLabels sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.appBar + 1,
            justifyContent: "flex-end",
            height: 76,
            px: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[8],
        }}>
            <Stack sx={{
                width: "100%", height: "100%", 
                //backgroundImage: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${theme.palette.CommonBlack.main} 100%)`,
                backgroundSize: '100% 100%', // adjust the size to your liking
                backgroundPosition: '0% 0%',
                backgroundRepeat: 'no-repeat',
                justifyContent: "flex-end",
                alignItems: "flex-end",
                flexDirection:"row"
            }}>
                {childrenActions}
                <CommonBtn variant='contained' sx={{ my: 1.5, ml: 1.5, borderRadius: 10, padding: 2, minWidth: 150 }} onClick={onSave} disabled={disabled}>{saveLabel}</CommonBtn>
            </Stack>
        </BottomNavigation>
    )
}

export { BottomSaveBar };
